import React from 'react';

import heartIcon from 'src/public/img/undraw-heartbroken-cble.svg';

import * as S from '../../stepComponents/styles';

const listElements = [
    'Talking to someone for support',
    'Spending time with your loved ones',
    'Spending time doing positive activities (e.g., sports, hobbies, reading)',
    'Sleeping enough',
    'Eating healthy meals',
    'Getting some exercise (not too much!)',
    'Trying to stick to a normal schedule',
    'Planning pleasant activities',
    'Taking breaks',
    'Using relaxation methods (breathing exercises, meditation, calming self-talk, soothing music)',
    'Participating in a support group ',
];

export const WhatHelpsStep: React.SFC = () => (
    <S.ContentRow>
        <S.ContentColumn md={14}>
            <S.StepHeading>What helps?</S.StepHeading>
            <S.BulletList>
                {listElements.map(element => (
                    <S.BulletListElement key={element}>{element}</S.BulletListElement>
                ))}
            </S.BulletList>
        </S.ContentColumn>
        <S.ContentColumn md={10}>
            <S.StepIcon iconUrl={heartIcon} />
        </S.ContentColumn>
    </S.ContentRow>
);
